<template>
  <h1>HEADER</h1>
</template>
<script>
import {Chart} from "highcharts-vue";
import Highcharts from "highcharts";
import moment from "moment";
import utility from "../../lib/utility";
import { mapState, mapActions } from "vuex";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, Media, PageOrientation, AlignmentType, HorizontalPositionAlign, VerticalPositionRelativeFrom, Table, TableCell, TableRow, RelativeHorizontalPosition, WidthType, VerticalAlign, TextRun, BorderStyle } from "docx";
import { saveAs } from "file-saver";
export default {
  components: {
    highcharts: Chart
  },
  data() {
    return {
      test_options: null,
      original_oprions: null,
      displayChart: false,
      showReport: null,
      dynamicDiv: [],
      mixedChart: null,
      displayText: "",
      label_position: "top",
      cType : false,
      form: {
        weighting: 1,
        type_search: "",
        frequency: ["900 MHz", "1800 MHz", "2100 MHz"],
        type_data: {
          quarterfrom: null,
          quarterto: null,
          yearfrom: null,
          yearto: null,
          monthto: null,
          monthfrom: null,
          monthOfyear: null,
          month: null,
          year: null,
          quarter: null,
          quarter_year_from: null,
          quarter_year: null
        },
        service_status: ['S','U','CS','CU'],
        graphAvg: 2,
        service_providers_sub: [],
        group: [],
        type_sele: "",
        type_report: "",
        year: "",
        quarter: "",
        compare_type: "provider"
      },
      options: {
        pieceLabel: {
          render: function(args) {
            return args.label + " " + args.value + "%";
          },
          overlap: true,
          fontSize: 14,
          fontStyle: "bold",
          fontColor: "#FFF"
        }
      },
      data: {},
      pending: false
    };
  },
  created() {
    var yyy = moment(new Date()).add(0, "y");
    this.defaultDate = yyy;
    this.$store.dispatch('Report_pmt/getGroupCompany','broadband')
    this.$store.dispatch('Report_pmt/getProviderByType','broadband')
  },
  computed: {
    ...mapState({
      store_groups : store => store.Report_pmt.provider_group,
      store_providers : store => store.Report_pmt.provider_list,
      store_charts : store => store.Report_SI.charts,
      showChart : store => store.Report_SI.showChart,
      showDataNotFound: store => store.Report_SI.showDataNotFound
    })
  },
  mounted() {},
  watch : {
    store_providers : {
      handler : function(reload, empty) {
        this.form.service_providers_sub = reload.map(provider => provider.id)
      }
    },
    store_charts : {
      handler : function(reload, empty){
        if (reload.length > 0) {
          document.getElementById('container').style.display = "block";
          this.displayChart = true
          let options = reload[0]
          options.chart.renderTo = 'container'
          var chart1 = new Highcharts.Chart(options);
        } else {
          this.displayChart = false
          document.getElementById('container').style.display = "none";
        }
      }
    }
  },
  methods: {
    ...mapActions({
      searching: 'Report_SI/setChartData',
    }),
    compareType(e){
      this.cType = e == 'group' ? true : false
      if(this.cType){
        this.form.service_providers_sub = []
      }else{
        this.form.group = []
      }
    },
    checkProviders(type) {
      if (this.form.group != "" && type == 2) {
        this.form.retail_service_provider = "";
      } else if (this.form.retail_service_provider != "" && type != 2) {
        this.form.group = "";
      }
    },
    clear_data() {
      this.form.type_data = {
        quarterfrom: null,
        quarterto: null,
        yearfrom: null,
        yearto: null,
        monthfrom: null,
        monthto: null,
        month: null,
        monthOfyear: null,
        year: null,
        quarter: null,
        quarter_year_from: null,
        quarter_year: null
      };
    },
    find_chart() {
      // เช็คการเลือกประเภทรายงาน
      if (this.form.type_report == "") {
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานรายเดือน month
      if (
        this.form.type_report == "month" &&
        this.form.type_data.month == null
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.month.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานระหว่างเดือน
      if (
        (this.form.type_report == "between_month" &&
          this.form.type_data.monthfrom == null) ||
        (this.form.type_report == "between_month" &&
          this.form.type_data.monthto == null)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.monthfrom == null) {
              this.$refs.monthfrom.focus();
            } else {
              this.$refs.monthto.focus();
            }
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานและช่วงเวลา year
      if (this.form.type_report == "year" && this.form.type_data.year == null) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.year.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานและช่วงเวลา between year
      if (
        (this.form.type_report == "between_year" &&
          this.form.type_data.yearfrom == null) ||
        (this.form.type_report == "between_year" &&
          this.form.type_data.yearto == null)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.yearfrom == null) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานและช่วงไตรมาส
      if (
        this.form.type_report == "quarter" &&
        this.form.type_data.quarter == null
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      //  ช็คการเลือกประเภทรายงานและช่วง quarterss
      if (
        (this.form.type_report == "between_quarter" &&
          this.form.type_data.quarterfrom == null) ||
        (this.form.type_report == "between_quarter" &&
          this.form.type_data.quarterto == null) ||
        (this.form.type_report == "between_quarter" &&
          this.form.type_data.quarter_year_from == null) ||
        (this.form.type_report == "between_quarter" &&
          this.form.type_data.quarter_year == null)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.quarterfrom == null) {
              this.$refs.quarterfrom.focus();
            } else if (this.form.type_data.quarterto == null) {
              this.$refs.quarterto.focus();
            } else if (this.form.type_data.quarter_year == null) {
              this.$refs.quarter_year2.focus();
            } else {
              this.$refs.quarter_year_from.focus();
            }
          }
        });
        this.displayText = "";
        return false;
      }
      if (this.form.compare_type=="group" && this.form.group.length == 0 ) {
        this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.group.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      else if(this.form.compare_type=="provider" && this.form.service_providers_sub.length == 0){
        this.$alert("กรุณาเลือกรายชื่อผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.group.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      if (this.form.type_search == "") {
        this.$alert("กรุณาเลือกประเภทเทคโนโลยี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            // this.$refs.type_search.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      let tableDiv = document.querySelectorAll('.highcharts-data-table');
          if (tableDiv.length > 0) {
            for(let i = 0; i < tableDiv.length; i++) {
              tableDiv[i].innerHTML = ''
            }
            
          }
      let formdata = this.form
      formdata.list = this.form.compare_type == "group" 
                    ? this.store_groups.filter(item => this.form.group.includes(item.id)) 
                    : this.store_providers.filter(item => this.form.service_providers_sub.includes(item.id))
      this.searching(formdata)
    },
    dashedBorder(myChart) {
      Chart.helpers.each(
        myChart.getDatasetMeta(0).data,
        function(rectangle, index) {
          rectangle.draw = function() {
            myChart.chart.ctx.setLineDash([0, 40]);
            Chart.elements.Rectangle.prototype.draw.apply(this, arguments);
          };
        },
        null
      );
    },
    async generatePDF() {
      this.pending = true
      var table = document.querySelector('.highcharts-data-table');
      if (table != null && table.children.length > 0) {
        var doc = new jsPDF("p","pt", [794, 1123]);
        var width = 794;
        var height = 1123;
      } else {
        var doc = new jsPDF("l","pt", [1123 ,794]);
        var width = 1123;
        var height = 794;
      }
      doc.internal.scaleFactor = 1.0;
      var chart_height = 0
      await this.$html2canvas(document.querySelector('#container'), {
          onclone: function(clone) {
            clone.querySelector('#container').style.marginLeft = 'auto';
            clone.querySelector('#container').style.marginRight = 'auto';
            clone.querySelector('#container').style.position = 'relative';
            clone.querySelector('#container').style.left = 0;
          }
        }).then(function(canvas) {
        const img = canvas.toDataURL("image/png", 1.0);
        chart_height = width*(canvas.height/canvas.width)
        doc.addImage(img, "JPEG", 0, 0, width, chart_height);
      }).then(()=>{
        this.pending = false
      })
      if (table != null && table.children.length > 0) {
        await this.$html2canvas(table, {
          canvas: null
        }).then(function(canvas) {
          const img = canvas.toDataURL("image/png", 1.0);
          var table_left = width*(canvas.height/canvas.width)
          doc.addImage(img, "JPEG", 0, chart_height, width, width*(canvas.height/canvas.width));
          // table_left -= ((table_left + chart_height) - height)
          table_left -= (table_left - chart_height)
          console.log(table_left)
          while(table_left >= 0) {
            let position = table_left - height
            // table_left -= (table_left + chart_height)
            console.log(table_left)
            doc.addPage();
            doc.addImage(img, "JPEG", 0, position, width, width*(canvas.height/canvas.width));
            table_left -= height
          }
        });
      }
      doc.save("report.pdf")

    },
    exportDoc(){
      this.pending = true
      setTimeout(()=>{
        this.pending = false
        // document.querySelector('#container').parentNode.style.overflow = 'visible'
        this.$html2canvas(document.querySelector('.highcharts-container'), {
          allowTaint: true,
          onclone: function(clone) {
            clone.querySelector('.highcharts-container').style.marginLeft = 'auto';
            clone.querySelector('.highcharts-container').style.marginRight = 'auto';
            clone.querySelector('.highcharts-container').style.position = 'relative';
            clone.querySelector('.highcharts-container').style.left = 0;
          }
        }).then(function(canvas) {
          const img = canvas.toDataURL("image/png", 2.0);
          let img_prop = canvas.width/canvas.height;
          var table = document.querySelector('.highcharts-data-table');
          const doc = new Document();
          let size = (table != null && table.children.length > 0) ? 560 : 920
          const image = Media.addImage(doc, img, size, size/img_prop)
          if (table != null && table.children.length > 0) {
            var temp_table = table.children[0]
            var header = temp_table.children[1]
            header = header.children[0]
            var body = temp_table.children[2]
            let cell = []
            var temp_row = []
            for(let i = 0; i < header.children.length; i++) {
              cell.push(
                new TableCell({
                  width: {size: 100/header.children.length, type: WidthType.PERCENTAGE},
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: header.children[i].textContent,
                          size: 14
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ] 
                })
              )
            }
            temp_row.push(new TableRow({
              children: cell
            }))
            cell = []
            for(let i = 0; i < body.children.length; i++) {
              let row = body.children[i]
              for(let j = 0; j < row.children.length; j++) {
                cell.push(
                  new TableCell({
                    width: {size: 100/header.children.length, type: WidthType.PERCENTAGE},
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: row.children[j].textContent,
                            size: 14
                          })
                        ],
                        alignment: AlignmentType.CENTER
                      })
                    ] 
                  })
                )
              }
              temp_row.push(new TableRow({
                children: cell
              }))
              cell = []
            }
            var data_table = new Table({alignment: AlignmentType.CENTER, rows: temp_row})
          }
          let export_data = (table != null && table.children.length > 0) ? [new Paragraph({children: [image], alignment: AlignmentType.CENTER}),  data_table] : [new Paragraph({children: [image], alignment: AlignmentType.CENTER})];
          doc.addSection({
            size: {
              orientation: (table != null && table.children.length > 0) ? PageOrientation.PORTRAIT : PageOrientation.LANDSCAPE,
            },
            children: export_data,
          });
          Packer.toBlob(doc).then(blob => {
            saveAs(blob, "services_inernet_report.doc");
          });
        });
      },2000)
    },
    async exportImage() {
      this.pending = true
      let div = document.querySelector('.export')
      await this.$html2canvas(div, {
        canvas: null,
        onclone: function(clone) {
          clone.querySelector('.export').style.marginLeft = 'auto';
          clone.querySelector('.export').style.marginRight = 'auto';
          clone.querySelector('.export').style.position = 'relative';
          clone.querySelector('.export').style.left = 0;
        }
      }).then(function (canvas) {
        const canvas_image = canvas.toDataURL("image/png", 1.0);
        let img = new Image();
        img.src = canvas_image;
        img.onload = function (data) {
          saveAs(data.path[0].src, "services_internet_report.png");
        }
      }).then(()=>{
        setTimeout(() => {
          this.pending = false
        }, 500);
      })
    },
    exportFile(com) {
      if(com == 'doc') {
        this.exportDoc()
      } else if (com == 'pdf') {
        this.generatePDF()
      } else if (com == 'image') {
        this.exportImage()
      }
    },
  }
};
</script>
<style>
  th.text.highcharts-table-topheading {
    vertical-align: middle
  }
  .highcharts-data-table tr,
  .highcharts-data-table th,
  .highcharts-data-table td {
    border: 1px solid silver;
    height: 20px!important;
    min-width: 100px;
    max-width: 300px!important;
  }
  .highcharts-table-caption {
    display: none;
  }
  .highcharts-data-table table{
    width: auto;
    margin-left: auto;
    margin-right: auto;
  }
</style>